export default "__VITE_ASSET__oZAKeR8Q__"